export default __webpack_public_path__ + "static/media/SidebarLogo.1ac673a8.svg";